import {
  commonActions,
  commonGetters,
  commonMutations
} from '@/store/store_utils'
import {
  isWithinMonthAgeRange,
  toCommonInstrumentCode
} from '@/utils/measurement_utils'

const dataName = 'laboratoryReferenceRanges'

const state = {
  laboratoryReferenceRanges: [],
  updatedAt: '20101010101010'
}

const getters = {
  ...commonGetters(dataName, ['getData', 'getUpdatedAt'], { filterDel: true }),
  getLaboratoryReferenceRange: state => (
    masterLaboratoryInstrumentCode, // 空文字のパターンはない
    masterLaboratoryItemCode,
    masterLaboratorySpeciesCode, // 空文字ではこの処理に到達しない
    patientBirthday,
    runDate // 空文字のパターンはない
  ) => {
    return state.laboratoryReferenceRanges.find(range => {
      const commonInstrumentCode = toCommonInstrumentCode(
        masterLaboratoryInstrumentCode
      )
      return (
        range.masterLaboratoryItemCode === masterLaboratoryItemCode &&
        range.masterLaboratoryInstrumentCode === commonInstrumentCode &&
        range.masterLaboratorySpeciesCode === masterLaboratorySpeciesCode &&
        isWithinMonthAgeRange(range, patientBirthday, runDate)
      )
    })
  }
}

const actions = {
  ...commonActions(['setData', 'setUpdatedAt', 'updateAfter'])
}

const mutations = {
  ...commonMutations(dataName, ['setData', 'setUpdatedAt', 'updateAfter'], {})
}

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
}
